import { render, staticRenderFns } from "./LoginGoverment.vue?vue&type=template&id=aa2d6d74&scoped=true"
import script from "./LoginGoverment.vue?vue&type=script&lang=js"
export * from "./LoginGoverment.vue?vue&type=script&lang=js"
import style0 from "./LoginGoverment.vue?vue&type=style&index=0&id=aa2d6d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2d6d74",
  null
  
)

export default component.exports